import React, { MouseEventHandler } from 'react'

interface Props extends React.ComponentPropsWithRef<'div'> {
  onClick: MouseEventHandler<HTMLDivElement>
}

export const CustomToggle = ({ children, onClick, ref }: Props) => {
  return (
    <div
      ref={ref}
      onClick={e => {
        e.preventDefault()
        onClick(e)
      }}
    >
      {children}
    </div>
  )
}
